import React from "react";
import SEO from "../shared/SEO";
import image1 from "../../assets/image1.png";
import backImage1 from "../../assets/backImage1 (2).png";
import backImage2 from "../../assets/backImage2.png";
import backImage3 from "../../assets/backImage3.png";
import backImage4 from "../../assets/Group 14.png";
import backImage5 from "../../assets/backImage5.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import image5 from "../../assets/image5.png";
import group4 from "../../assets/Group 4.png";
import vectorLeft1 from "../../assets/vector-left-1.png";
import vectorLeft2 from "../../assets/vector-left-2.png";
import vectorLeft3 from "../../assets/vector-left-3.png";
import vectorRight1 from "../../assets/vector-right-1.png";
import vectorRight2 from "../../assets/vector-right-2.png";
import vectorRight3 from "../../assets/vector-right-3.png";
import vectorCenter1 from "../../assets/Vector-center-1.png";
import vectorCenter2 from "../../assets/Vector-center-2.png";
import vectorCenter3 from "../../assets/vector-center-3.png";
import layerBlur from "../../assets/layer-blur.png";
import ellipse1 from "../../assets/Ellipse 1.png";
import ellipse2 from "../../assets/Ellipse 2.png";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import Special from "./Special";
import ebook1 from "../../assets/ebook1.svg";
import ebook2 from "../../assets/ebook2.svg";
import image6 from "../../assets/loginImage5.png";
import f6sNetworkPartnerWhite from "../../assets/F6S-network-partner-alternative.png";
import { FaCheck } from "react-icons/fa";
const Homepage: React.FC = () => {
  const navigate = useNavigate();
  const benefits = [
    {
      id: 1,
      front: image1,
      back: backImage1,
      title: "Learn",
      description: "Gain insight through our eBook: The Orca Blueprint.",
    },
    {
      id: 2,
      front: image2,
      back: backImage2,
      title: "Build",
      description:
        "Access our AI-powered pitch deck generator and our startup studio to help refine and optimize your pitch and product alike",
    },
    {
      id: 3,
      front: image3,
      back: backImage3,
      title: "Pitch",
      description: "Receive expert feedback and scoring on your pitch",
    },
    {
      id: 4,
      front: image4,
      back: backImage4,
      title: "Get Funded",
      description:
        "Compete for angel investments with up to $100K in funding opportunities over two seasonal batches per year",
    },
    {
      id: 5,
      front: image5,
      back: backImage5,
      title: "Connect",
      description:
        "Connect with a thriving entrepreneurial community and investors.",
    },
  ];
  const handleApplyNow = () => {
    navigate("/auth");
  };
  return (
    <div className="bg-white">
      <SEO
        title="The Orcas Valley | Learn, Build, Pitch and Fund Your Startup"
        description="Build your startup step by step. Learn with The Orca Blueprint, create AI-powered pitch decks, scout investors and access angel funding opportunities."
        url="https://orcasvalley.web.app"
        keywords="startup accelerator, pitch deck generator, startup funding, entrepreneur, business plan, investor portal, startup tools"
      />
      <Navbar />

      {/* Hero Section */}
      <header className="relative text-white text-left h-[85vh]  flex items-center justify-center px-6 md:px-10">
        {/* Background Image Container */}
        <div className="absolute inset-0 px-6 md:px-10 py-2 md:py-0">
          <div
            className="w-full h-full bg-cover bg-center rounded-xl"
            style={{ backgroundImage: "url('/landingPageHeroSection.svg')" }}
          ></div>
        </div>

        {/* Overlay */}
        {/* <div className="absolute inset-0 bg-white/10 backdrop-blur-sm rounded-xl"></div> */}

        {/* Vertical Text */}
        <div className="absolute top-6 left-3 sm:top-10  xs:left-2 sm:left-6 md:left-10  z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest  sm:flex">
          <div className="border-l-2 border-gray-300 h-8 md:h-10 mb-2"></div>
          <p className="flex flex-col text-center text-xs ">
            <span>T</span>
            <span>H</span>
            <span>E</span>
            <br />
            <span>O</span>
            <span>R</span>
            <span>C</span>
            <span>A</span>
            <span>S</span>
            <br />
            <span>W</span>
            <span>A</span>
            <span>Y</span>
          </p>
        </div>

        {/* Content Section */}
        <div className="relative z-10 w-full flex flex-col md:flex-row items-end px-6 md:px-20 py-16 md:py-20">
          <div className="text-center md:text-left mt-32 md:mt-44 w-full">
            <h1 className="text-4xl md:text-6xl font-medium leading-tight">
              Shaping Ideas into <br className="hidden md:block" /> Success
              Stories
            </h1>
            <p className="mt-4 text-sm md:text-lg text-gray-300">
              Learn, Build, Pitch, and Get Funded | Step-by-step framework for{" "}
              <br className="hidden md:block" />
              founders building real startups.
            </p>

            {/* Buttons */}
            <div className="mt-6 flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-3">
              <button
                onClick={handleApplyNow}
                className="px-6 py-2 bg-white  hover:bg-[#2CFFCC] text-black  rounded-full font-light flex items-center space-x-2 shadow-md"
              >
                <span>Apply Now</span>
                <span className="text-lg">→</span>
              </button>
              <span className="text-gray-400 text-lg hidden sm:block">•</span>
              <button className="text-gray-300 font-light">
                Become an Orca
              </button>
            </div>
          </div>
        </div>
      </header>

      <section className="relative flex flex-col items-center justify-center text-center py-16 px-6  bg-white overflow-hidden">
        {/* Left Patch - Overlapping Text */}
        <img
          src={ellipse2}
          alt="Left Gradient Patch"
          className="absolute left-[-50px] top-[-30%] w-[420px] opacity-80 blur-xl"
        />

        {/* Right Patch - Overlapping Text */}
        <img
          src={ellipse1}
          alt="Right Gradient Patch"
          className="absolute right-[-50px] top-[-10%] w-[420px] opacity-80 blur-xl scale-x-[-1]"
        />

        {/* Content Box */}
        <h2 className="relative text-[24px] md:text-[26px] font-light text-gray-900 leading-relaxed max-w-3xl z-10">
          <img
            src={group4}
            alt="Decorative Icon"
            className="w-6 h-6 md:w-8 md:h-8 mt-1  "
          />
          {/* <span className="ml-16 font-light">
            The Orcas Valley is a comprehensive platform designed{" "}
          </span> */}
         <div className="inline-block text-left indent-20">
          
      The Orcas Valley is a comprehensive platform designed
  specifically for first-time founders and aspiring entrepreneurs. No
  experience? No problem. We provide clear, step-by-step guidance to
  transform your ideas into successful startups. Our resources include
  The Orca Blueprint: The Art of Building and Scaling Your Startup, an
  AI-powered pitch deck generator, competitive angel investment
  opportunities, and access to an extensive network of angel investors
  ready to support your growth. {" "}
  <img
    src={group4}
    alt="Decorative Icon"
    className="inline-block ml-10 w-6 h-6 md:w-8 md:h-8 align-baseline"
  />
</div>
        </h2>
        {/* <img 
    src={ellipse1}
    alt="Right Gradient Patch" 
    className="absolute left-[-50px] top-[-10%] w-[420px] opacity-80 blur-xl scale-x-[-1]"
  /> */}

        {/* Button */}
        <button className="mt-6 px-6 py-3 bg-[#02C4A1] hover:bg-[#072928] text-white rounded-full font-normal  shadow-md  transition flex items-center space-x-2 relative z-10">
          Ready to Build Your Dream Company? →
        </button>
      </section>
      {/* Parent Wrapper for Both Sections */}
      <div className="relative ">
        {/* Key Benefits */}
        <section className="relative text-center py-20 z-10 mb-10">
          {/* Section Header */}
          <div className="flex items-center justify-center mb-8 relative px-4">
            <div className="w-full max-w-6xl flex items-center">
              <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-green-300 to-green-300"></div>
              <h3 className="text-3xl md:text-4xl font-light px-4 whitespace-nowrap">
                Key Benefits
              </h3>
              <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent via-green-300 to-green-300"></div>
            </div>
          </div>

          {/* Background Image */}
          <div
            className="absolute bottom-0 left-0 w-full h-[300px] md:h-[500px] bg-no-repeat bg-left-top"
            style={{ backgroundImage: "url('/key benefits-bg.png')" }}
          ></div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-4 sm:gap-6 max-w-6xl mx-auto px-4 md:px-0">
            {benefits.map((benefit) => (
              <div
                key={benefit.id}
                className="relative group bg-white rounded-[20px] sm:rounded-[30px] shadow-md h-64 sm:h-72 overflow-hidden"
              >
                {/* Front Image (Default View) */}
                <img
                  src={benefit.front}
                  alt="Front"
                  className="h-full w-full object-cover rounded-[20px] sm:rounded-[30px] absolute inset-0 transition-opacity duration-500 group-hover:opacity-0"
                />

                {/* Back Image with Text (Appears on Hover) */}
                <div className="absolute inset-0 flex flex-col justify-start text-left bg-opacity-95 opacity-0 transition-opacity duration-500 group-hover:opacity-100 py-0 rounded-[20px] sm:rounded-[30px]">
                  <img
                    src={benefit.back}
                    alt="Back"
                    className="h-full w-full object-cover absolute inset-0 rounded-[20px] sm:rounded-[30px]"
                  />

                  <div className="relative flex flex-col h-full justify-start gap-24 z-10 px-3 py-3 sm:px-4 sm:py-4 text-gray-700 font-light">
                    <h3 className="text-lg sm:text-xl font-normal">
                      {benefit.title}
                    </h3>

                    <p className="text-xs sm:text-sm mb-5">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
        {/* Special Section */}
        <Special />

        <section className="w-full bg-white px-6 py-12 lg:px-24 lg:py-20 flex flex-col-reverse lg:flex-row items-start lg:items-start lg:justify-center">
          <div className="flex items-start justify-start w-full sm:w-[90%] lg:w-[40%]">
            <div className="w-full space-y-2 text-left lg:text-left ">
              <h3 className="text-xl font-normal text-gray-500 mt-2">
                AI Pitch Builder
              </h3>

              <h1 className="text-3xl lg:text-4xl font-semibold text-gray-800 leading-snug">
                Create Investor- <br className="hidden lg:block" />
                Ready Decks <span className="text-[#02C4A1]" >Instantly</span>
              </h1>
              <div className="mt-10">
                <p className="text-gray-600 leading-relaxed mb-10 ">
                  Craft your pitch deck in minutes with our AI-powered pitch
                  builder. Designed for founders at all stages, the builder asks
                  the right questions, applies proven frameworks, and generates
                  compelling, branded slides automatically.
                </p>
              </div>

              <ul className="text-gray-700 text-left  lg:mx-0 w-fit mt-10">
                <li className="flex mb-2 text-black">
                  <FaCheck className="text-black mr-2" /> Custom-branded for
                  your startup
                </li>
                <li className="flex mb-2 text-black">
                  <FaCheck className="text-black mr-2" /> Easy-to-use, no design
                  skills needed
                </li>
                <li className="flex mb-2 text-black">
                  <FaCheck className="text-black mr-2" /> Includes visuals,
                  charts, and messaging
                </li>
                <li className="flex mb-2 text-black">
                  <FaCheck className="text-black mr-2" /> Investor scouting
                  portal
                </li>
              </ul>

              <div>
                <button
                  className="bg-[#02C4A1] hover:bg-[#072928] text-white font-normal px-6 py-2 rounded-full shadow transition duration-300 mt-5"
                   onClick={() => {
                  navigate("/auth");
                  window.scrollTo(0, 0);
                }}
                >
                  Build Your Pitch Deck →
                </button>
              </div>
            </div>
          </div>

          <div className="w-full h-full lg:w-[60%] mt-8 lg:mt-0 flex justify-center lg:justify-end">
            <div
  className="w-full lg:w-[90%] h-[55vh] xl:h-[50vh] bg-white flex items-center justify-center text-gray-700 text-lg font-medium rounded-md shadow-inner bg-no-repeat bg-center bg-contain"
  style={{
    backgroundImage: `url("${image6}")`,
  }}
></div>
          </div>
        </section>

        <section className="w-full bg-white px-6 py-12 lg:px-24 lg:py-20 flex flex-col lg:flex-row items-center lg:items-start lg:justify-center">
          <div className="w-full lg:w-[55%] flex justify-center lg:justify-start">
            <div className="w-full lg:w-[90%] h-[55vh] xl:h-[60vh] flex">
              <div
                className="flex-1 h-[70%] w-[50%] bg-white flex items-center justify-center text-gray-700 text-lg font-medium rounded-md shadow-inner"
                style={{
                  backgroundImage: `url(${ebook1})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center right",
                }}
              ></div>

              <div
                className="flex-1 mt-28 h-[70%] w-[50%] -ml-1 flex items-center justify-center text-gray-700 text-lg font-medium rounded-md shadow-inner"
                style={{
                  backgroundImage: `url(${ebook2})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center left",
                }}
              ></div>
            </div>
          </div>

          <div className="w-full lg:w-[40%] mt-8 lg:mt-0 lg:ml-12 space-y-4 text-left">
            <h3 className="text-xl font-normal text-gray-500">
              Your Startup Companion
            </h3>

            <h1 className="text-3xl lg:text-4xl font-semibold text-gray-800 leading-snug">
              The Orca Blueprint: <br className="hidden lg:block" />
              <span className="text-[#02C4A1]">From Idea to <br /> Launch</span>
            </h1>
            <div className="mt-10">
              <p className="text-gray-600 leading-relaxed mb-8">
                This essential e-book guides you through the art of building and
                scaling a startup, from initial idea to successful launch.
                Packed with insights from real-world experience, it’s your
                step-by-step blueprint for entrepreneurial success.
              </p>
            </div>

            <ul className="text-gray-700 text-left w-fit mt-6">
              <li className=" flex mb-2 ">
                <FaCheck className="text-black mr-2" /> Clear guidance across
                every stage
              </li>
              <li className="flex mb-2">
                <FaCheck className="text-black mr-2" /> Actionable advice for
                new founders
              </li>
              <li className="flex mb-2 ">
                <FaCheck className="text-black mr-2" /> Perfect for early-stage
                entrepreneurs
              </li>
              <li className="flex mb-2 ">
                <FaCheck className="text-black mr-2" />
                Written by Hasan Rteil, founder of&nbsp;
                <span className="text-[#02C4A1]">Orcas Valley</span>
              </li>
            </ul>

            <div>
              <button
                className="bg-[#02C4A1] hover:bg-[#072928] text-white font-normal px-6 py-2 rounded-full shadow transition duration-300 mt-5"
                onClick={() => {
                  navigate("/auth");
                  window.scrollTo(0, 0);
                }}
              >
                Get Your Copy →
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Partners Section */}
      <section className="py-16 bg-gradient-to-b from-gray-900 to-black text-white">
        <div className="container mx-auto px-4">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Our Partners
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              We collaborate with leading organizations to bring you the best tools and resources for your success.
            </p>
          </div>

          {/* Partners Grid */}
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16">
            {/* F6S Network Partner */}
            <div className="group flex flex-col items-center">
              <a
                href="https://www.f6s.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transform transition-all duration-300 hover:scale-105"
              >
                <div className="bg-gray-800 rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-700">
                  <img
                    src={f6sNetworkPartnerWhite}
                    alt="F6S Network Partner"
                    className="h-20 w-auto"
                  />
                </div>
                <p className="text-center mt-4 text-sm text-gray-400 group-hover:text-[#02C4A1] transition-colors duration-200">
                  Startup Network Platform
                </p>
              </a>
            </div>
          </div>

          {/* Partnership Info */}
          <div className="mt-16 bg-gradient-to-r from-[#02C4A1]/10 to-transparent rounded-lg p-8 text-center border border-[#02C4A1]/20">
            <h3 className="text-2xl font-semibold mb-4">
              Interested in Partnering with Us?
            </h3>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Join our growing network of partners and help startups and businesses create amazing presentations.
            </p>
            <button
              onClick={() => {
                navigate('/contact-us');
                window.scrollTo(0, 0);
              }}
              className="bg-[#02C4A1] text-white font-semibold py-3 px-8 rounded-lg hover:bg-[#02C4A1]/80 active:scale-95 transition-all duration-300"
            >
              Get in Touch
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;
